import { render, staticRenderFns } from "./SettingsReadingLanguages.vue?vue&type=template&id=52731406&"
import script from "./SettingsReadingLanguages.vue?vue&type=script&lang=ts&"
export * from "./SettingsReadingLanguages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports